import { createEntityAdapter, createSelector, createSlice, nanoid } from '@reduxjs/toolkit'

export const SUB_KEY = 'subscriptions'

export interface SubscriptionsState {
  id: string
  isOpen: boolean
}

export const SubscriptionsAdapter = createEntityAdapter<SubscriptionsState>()

export const initialSubscriptionsState: SubscriptionsState = SubscriptionsAdapter.getInitialState({
  id: nanoid(),
  isOpen: false,
})

export const SubscriptionsSlice = createSlice({
  name: SUB_KEY,
  initialState: initialSubscriptionsState,
  reducers: {
    open: (state) => {
      state.isOpen = true
    },
    close: (state) => {
      state.isOpen = false
    },
  },
})

export const SubscriptionsReducer = SubscriptionsSlice.reducer
export const SubscriptionsActions = SubscriptionsSlice.actions

export const getSubscriptionsState = (rootState: { [x: string]: SubscriptionsState }): SubscriptionsState => {
  return rootState[SUB_KEY]
}

export const SubscriptionsSelectors = {
  getIsOpen: createSelector(getSubscriptionsState, (state: SubscriptionsState) => state.isOpen),
}
